<template>
  <div v-if="availableLists?.length > 0" class="top-scoring-list-selector">
    <div
      v-for="list in availableLists"
      :key="`top-scoring-list-${list.id}`"
      class="top-scoring-list-selector-item"
      @click="$emit('selectList', list.id)"
    >
      {{ list.name }}
    </div>
  </div>

  <NotificationBanner
    v-else
    :message="$t('top-scoring-lists.no-available-lists')"
  />
</template>

<script lang="ts" setup>
import { PropType } from 'vue'

import NotificationBanner from '@/components/common/NotificationBanner.vue'
import { TopScoringListInfo } from '@/store/modules/top-scoring-lists.types'

defineEmits(['selectList'])

defineProps({
  availableLists: {
    type: Array as PropType<TopScoringListInfo[]>,
    default: () => [],
  },
})
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/globals';

.top-scoring-list-selector {
  display: grid;
  gap: 1em;

  .top-scoring-list-selector-item {
    background-color: $color-background;
    padding: 1em;
    box-shadow: 0 0 0.25em $color-border;
    border: none;
    border-radius: 0.5em;
    cursor: pointer;
    transition: transform $default-transition;

    &:hover {
      transform: scale(1.0125);
    }
  }
}
</style>
